var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_127446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7604 10.1871C19.7604 9.36773 19.6939 8.7698 19.55 8.14972H10.1934V11.848H15.6855C15.5748 12.7671 14.9769 14.1512 13.6481 15.0813L13.6295 15.2051L16.5879 17.497L16.7928 17.5174C18.6752 15.779 19.7604 13.2211 19.7604 10.1871",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1937 19.9313C12.8844 19.9313 15.1432 19.0454 16.7932 17.5174L13.6484 15.0813C12.8069 15.6682 11.6774 16.0779 10.1937 16.0779C7.55834 16.0779 5.32163 14.3395 4.5243 11.9366L4.40743 11.9466L1.33124 14.3273L1.29102 14.4391C2.92979 17.6945 6.29598 19.9313 10.1937 19.9313Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52477 11.9366C4.31439 11.3166 4.19264 10.6521 4.19264 9.96565C4.19264 9.27908 4.31439 8.61473 4.51371 7.99466L4.50813 7.8626L1.3934 5.44366L1.29149 5.49214C0.616073 6.84305 0.228516 8.36008 0.228516 9.96565C0.228516 11.5712 0.616073 13.0882 1.29149 14.4391L4.52477 11.9366",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1937 3.85336C12.065 3.85336 13.3273 4.66168 14.047 5.33718L16.8596 2.59107C15.1322 0.985496 12.8844 0 10.1937 0C6.29598 0 2.92979 2.23672 1.29102 5.49214L4.51323 7.99466C5.32163 5.59183 7.55834 3.85336 10.1937 3.85336",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_127446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.55,
    height: 20,
    fill: "white",
    transform: "translate(0.224609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1ec4204619bd19da177c84f5dfc5d17c.svg";
export { ForwardRef as ReactComponent };